import { render, staticRenderFns } from "./home.vue?vue&type=template&id=6f5e704a&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=6f5e704a&prod&scoped=true&lang=less"
import style1 from "./home.vue?vue&type=style&index=1&id=6f5e704a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5e704a",
  null
  
)

export default component.exports